import React from 'react';
import { MembersAnalytics } from './membersAnalyticsLogic';
import ProgressRing from './ProgressRing';

type CategorySummary = MembersAnalytics['categories'][number];

interface IProps {
  category: CategorySummary;
}

export default function RingMetricCard(props: IProps) {
  const { category } = props;

  return (
    <div className='members-analytics-engagement-ring'>
      <ProgressRing percent={category.engagementPercent} large>
        {category.engagementPercent}%
      </ProgressRing>
    </div>
  );
}
